import { useEffect, useMemo, useState } from "react";
import { ShoppingBag, Loader2 } from "lucide-react";
import { apiError } from "@/lib/api";
import { NUM } from "@/lib/format";
import { fetchHistory, withTrend, supplierStats, periodParams } from "./purchaseApi";
import { KpiStrip, SupplierTable, HistoryTable, ScanNotice, useDocOpen, PeriodFilter } from "./HistoryParts";

/** Ürün detayı: bu ürünü aldığınız tedarikçiler ve alış faturaları (en yeniden eskiye). */
export function PurchaseHistoryPanel({ productId, compact }) {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [ver, setVer] = useState(0);
  const [per, setPer] = useState({ period: "all", from: "", to: "" });
  const doc = useDocOpen();
  useEffect(() => {
    let live = true;
    setRes(null); setErr("");
    fetchHistory({ product_id: productId, limit: 1000, ...periodParams(per) }).then((d) => { if (live) setRes(d); }).catch((e) => { if (live) setErr(apiError(e)); });
    return () => { live = false; };
  }, [productId, ver, per]);
  const rows = useMemo(() => withTrend(res?.rows || []), [res]);
  return (
    <div className="rounded-xl border overflow-hidden" data-testid={`purchase-history-${productId}`}>
      <div className="px-4 py-2.5 border-b bg-muted/40 text-xs font-bold uppercase tracking-widest text-muted-foreground flex items-center gap-1">
        <ShoppingBag className="h-3.5 w-3.5" />Alış Geçmişi · Tedarikçiler & Faturalar{res ? ` (${NUM(res.total)})` : ""}
      </div>
      <div className="p-3 space-y-3">
        <PeriodFilter value={per} onChange={setPer} compact />
        {!res && !err && <div className="py-6 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>}
        {err && <p className="text-sm text-destructive">{err}</p>}
        {res && !rows.length && <p className="text-sm text-muted-foreground text-center py-3" data-testid="ph-panel-empty">{per.period === "all" ? "Bu ürün için alış faturası bulunamadı." : "Seçili dönemde bu ürün için alış faturası yok."}</p>}
        {res && <ScanNotice unscanned={res.unscanned} onDone={() => setVer((v) => v + 1)} />}
        {rows.length > 0 && (
          <>
            <KpiStrip rows={rows} compact={compact} />
            <SupplierTable stats={supplierStats(rows)} compact />
            <HistoryTable rows={rows} doc={doc} compact />
          </>
        )}
      </div>
      {doc.dialog}
    </div>
  );
}
